import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
 :root {
  --globe-red: #9B1417;
  --globe-blue: #005DC7;
  --globe-dkgray: #767676;
  --globe-offwhite: #F4F4F4;
  --globe-link: #005DC7;
  --offblack: #333;
  --offwhite: #efefef;
  --content-max-width: 1000px;

  --custom-dark: #36333c;
  --custom-red: #ec5f47;
  --custom-white: #eae1da;
  --custom-blue: #546270;

  --maxWideScreen: 1380px;

  --customShadow: 0 3px 8px rgba(0,0,0,1);
 }
`;

export default GlobalStyles;
